/* eslint-disable no-param-reassign */
import { decorate, observable, action } from 'mobx';

import { encodeUuids } from '../../utils/parse-encode-uuids';

import { getAvailableDates } from '../../apis/six-api/v1/schedules';
import { getAvailableDatesV2 } from '../../apis/six-api/v2/schedules';

export default class AvailableDatesStore {
  isLoading = false;
  isFailure = false;
  hasFormError = false;
  hasUnavailableTechniciansError = false;

  dates = [];

  getAvailableDates = async integrationId => {
    try {
      this.isFailure = false;
      this.isLoading = true;

      const {
        data: { records },
      } = await getAvailableDates(integrationId);

      this.handleGetAvailableDatesResponse(records);
    } catch (error) {
      this.isLoading = false;
      this.isFailure = true;
    } finally {
      this.isLoading = false;
    }
  };

  getAvailableDatesV2 = async integrationIds => {
    try {
      this.isFailure = false;
      this.isLoading = true;

      const {
        data: { records },
      } = await getAvailableDatesV2(encodeUuids(integrationIds));

      this.handleGetAvailableDatesResponse(records);
    } catch (error) {
      this.isFailure = true;
    } finally {
      this.isLoading = false;
    }
  };

  setSelectedDate = date => {
    this.dates.forEach(d => {
      if (d.date === date) {
        d.selected = true;
      } else {
        d.selected = false;
      }
    });
  };

  getSelectedDate() {
    return this.dates.filter(d => d.selected === true)[0];
  }

  handleError(value) {
    this.hasFormError = value;
  }

  handleGetAvailableDatesResponse = records => {
    if (records[0].erro && records[0].erro === 9) {
      this.hasUnavailableTechniciansError = true;
    } else {
      const { dates } = records[0];

      this.dates = this.addSelectedAttribute(dates);
    }
  };

  addSelectedAttribute = arr => {
    return arr.map(item => ({
      ...item,
      selected: false,
    }));
  };
}

decorate(AvailableDatesStore, {
  isLoading: observable,
  isFailure: observable,
  hasFormError: observable,
  hasUnavailableTechniciansError: observable,
  dates: observable,
  getAvailableDates: action,
  getAvailableDatesV2: action,
  setSelectedDate: action,
  getSelectedDate: action,
  handleError: action,
});

const availableDatesStore = new AvailableDatesStore();

export { availableDatesStore };
